import { Router } from 'framework7/types';
import { SubscriptionCarSelectPage } from '@/components/pages/Subscription/SubscriptionCarSelectPage';
import { SubscriptionCompletePage } from '@/components/pages/Subscription/SubscriptionCompletePage';
import { SubscriptionConfirmPage } from '@/components/pages/Subscription/SubscriptionConfirmPage';
import { SubscriptionDetailPage } from '@/components/pages/Subscription/SubscriptionDetailPage';
import { SubscriptionInheritancePage } from '@/components/pages/Subscription/SubscriptionInheritancePage';
import { SubscriptionMyPage } from '@/components/pages/Subscription/SubscriptionMyPage';
import { SubscriptionPaymentPage } from '@/components/pages/Subscription/SubscriptionPaymentPage';
import { paths } from '@/config/paths';

export const subscriptionRoutes: Router.RouteParameters[] = [
  {
    path: paths.subscriptionDetail,
    component: SubscriptionDetailPage,
    name: 'マイくるプラス',
  },
  {
    path: paths.subscriptionPaymentStatus(':status'),
    component: SubscriptionPaymentPage,
    name: '決済方法選択',
  },
  {
    path: paths.subscriptionPayment,
    component: SubscriptionPaymentPage,
    name: '決済方法選択',
  },
  {
    path: paths.subscriptionCarSelect,
    component: SubscriptionCarSelectPage,
    name: '車両選択',
  },
  {
    path: paths.subscriptionInheritance,
    component: SubscriptionInheritancePage,
    name: '保証引き継ぎ申込',
  },
  {
    path: paths.subscriptionConfirm,
    component: SubscriptionConfirmPage,
    name: '申込確認',
  },
  {
    path: paths.subscriptionComplete,
    component: SubscriptionCompletePage,
    name: '申込完了',
  },
  {
    path: paths.subscriptionMyPage,
    component: SubscriptionMyPage,
    name: 'サブスクリプション契約',
  },
];
